<template>
    <div class="homeCarousel">
        <el-carousel>
            <el-carousel-item v-for="(item,index) in carouselData" :key="index">
                <img :src="item" alt="" class="homeCarouselImg">
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    name: "carousel",
    data() {
        return {
            carouselData:[require('@/assets/home/carousel1.png'),require('@/assets/home/carousel2.png'),require('@/assets/home/carousel3.png')],
        }
    },
    mounted(){
        //初始化动画
        this.$nextTick(()=>{
            this.$wow.init()
        })
    }
}
</script>

<style lang="scss">
    :root {
        --web-max-width: 1920px;
        --web-min-width: 1300px;
    } 
    .homeCarousel{
      .el-carousel__container{
        min-width:var(--web-min-width);
        // max-width:var(--web-max-width);
        height: 746px;
        margin:0 auto;
      }
      .homeCarouselImg{
        height: 100%;
        min-height: 570px;
        // width: auto;
        cursor: pointer;
      }
    }
  
</style>